import { connect } from 'react-redux';
import AdminTabList from './AdminTabList';
import {
  getResponsiblePersonsOnStock,
  modalResponsiblePersonsOnStockOpen,
  delResponsiblePersonOnStock
} from '../../store/actions/responsiblePerson';
import { getSettingsPlantStorageTime } from '../../store/actions/stock';

const mapStateToProps = ({
  responsiblePersonReducer,
  stockReducer,
  userReducer,
  tabsReducer
}) => ({
  responsiblePersonReducer,
  stockReducer,
  userReducer,
  tabsReducer
});
const mapDispatchToProps = {
  getResponsiblePersonsOnStock,
  modalResponsiblePersonsOnStockOpen,
  delResponsiblePersonOnStock,
  getSettingsPlantStorageTime
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminTabList);
